import { render, staticRenderFns } from "./WeedList.vue?vue&type=template&id=363c6c3e&scoped=true&"
import script from "./WeedList.vue?vue&type=script&lang=ts&"
export * from "./WeedList.vue?vue&type=script&lang=ts&"
import style0 from "./WeedList.vue?vue&type=style&index=0&id=363c6c3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363c6c3e",
  null
  
)

export default component.exports